"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTimeout = setTimeout;
exports.clearTimeout = clearTimeout;
var worker_timers_1 = require("../vendor/frontend/worker-timers");
var clearByTimerHandle = new WeakMap();
function setTimeout(callback, delay) {
    var callback_actual = function () {
        document.removeEventListener("visibilitychange", visibilityChangeListener);
        clearByTimerHandle.delete(timerHandle);
        callback();
    };
    var timerHandle_n = worker_timers_1.workerTimers.setTimeout(callback_actual, delay);
    var timerHandle = {};
    clearByTimerHandle.set(timerHandle, function () {
        clearByTimerHandle.delete(timerHandle);
        worker_timers_1.workerTimers.clearTimeout(timerHandle_n);
        document.removeEventListener("visibilitychange", visibilityChangeListener);
    });
    var start = Date.now();
    var visibilityChangeListener = function () {
        if (document.visibilityState === "visible") {
            worker_timers_1.workerTimers.clearTimeout(timerHandle_n);
            var elapsed = Date.now() - start;
            if (elapsed < delay) {
                timerHandle_n = worker_timers_1.workerTimers.setTimeout(callback_actual, delay - elapsed);
            }
            else {
                callback_actual();
            }
        }
    };
    document.addEventListener("visibilitychange", visibilityChangeListener);
    return timerHandle;
}
function clearTimeout(handle) {
    var clear = clearByTimerHandle.get(handle);
    if (clear === undefined) {
        return;
    }
    clear();
}
//# sourceMappingURL=workerTimers.js.map